import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { AUDIT_PERIOD_OPTIONS } from './_filter-options';

/**
 * Select de período compartilhado pelas filter bars admin.
 *
 * Aceita `options` para customizar (Observability tem janela menor — sem
 * 30d, por exemplo). O label "Período" e a estrutura visual ficam aqui
 * para garantir consistência entre as telas.
 */
export interface PeriodOption<V extends string = string> {
  value: V;
  label: string;
}

interface PeriodSelectProps<V extends string = string> {
  value: V;
  onChange: (value: V) => void;
  options?: PeriodOption<V>[];
  /** Largura do trigger no breakpoint sm. Default: `sm:w-[130px]`. */
  width?: string;
  /** Sobrescreve o label visível ("Período" por padrão). */
  label?: string;
}

export function PeriodSelect<V extends string = string>({
  value,
  onChange,
  options,
  width = 'sm:w-[130px]',
  label = 'Período',
}: PeriodSelectProps<V>) {
  const opts = (options ?? (AUDIT_PERIOD_OPTIONS as unknown as PeriodOption<V>[]));
  return (
    <div className="space-y-1">
      <Label className="text-xs font-medium">{label}</Label>
      <Select value={value} onValueChange={(v) => onChange(v as V)}>
        <SelectTrigger className={`w-full ${width}`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {opts.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
